import { bffServiceClient } from 'packages/request/clients';
import {
  IParamSearchMerchant,
  IMerchantBFFResponse,
  IShopOfMerchantResponse,
  IMerchantResponse,
  IGetMerchantApproachingParams,
  IUpdateMerchantApproaching,
  IMerchantApproachHistory,
} from 'interfaces/merchant';
import { getResult, getData } from 'helpers/request';

const getMerchants = (
  params: IParamSearchMerchant
): Promise<IMerchantBFFResponse> => {
  return bffServiceClient.get(`/merchant`, { params }).then(getResult);
};
const getListShopOfMerchant = (
  id: number,
  params: IParamSearchMerchant
): Promise<IShopOfMerchantResponse> => {
  return bffServiceClient
    .get(`/merchant/${id}/shops`, { params })
    .then(getResult);
};
const getMerchantDetailById = (id: number): Promise<IMerchantResponse> => {
  return bffServiceClient.get('/merchant/' + id).then(getResult);
};

const getMerchantApproaching = (params: IGetMerchantApproachingParams) => {
  return bffServiceClient
    .get('/merApproachProcessStatistic', { params })
    .then(getResult);
};

const updateMerchantApproaching = (
  merchantId: number,
  payload: IUpdateMerchantApproaching
) => {
  return bffServiceClient.put(
    `/merApproachProcessStatistic/${merchantId}`,
    payload
  );
};

const exportProgressReport = (
  params: IGetMerchantApproachingParams
): Promise<{ filePath: string }> => {
  return bffServiceClient
    .get('/merApproachProcessStatistic/export', { params })
    .then(getData);
};

const getMerchantApproachHistory = (
  id: number
): Promise<{ merchantHistories: IMerchantApproachHistory[] }> => {
  return bffServiceClient
    .get(`/merApproachProcessStatistic/${id}/history`)
    .then(getData);
};

export default {
  getListShopOfMerchant,
  getMerchants,
  getMerchantDetailById,
  getMerchantApproaching,
  updateMerchantApproaching,
  exportProgressReport,
  getMerchantApproachHistory,
};
